function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.05,
  filter: "url(#product-1_svg__filter0_f)",
  stroke: "#000",
  strokeWidth: 2
}, React.createElement("path", {
  d: "M441 451.472c-181.022-12.28-508.68-62.63-371.14-165.785C207.4 182.532 387.832 234.519 398.7 155.378 413.319 48.948 97.422-3.448 3 24.388"
}), React.createElement("path", {
  d: "M441 437.827c-181.022-12.28-508.68-62.63-371.14-165.785C207.4 168.887 387.832 220.874 398.7 141.733 413.319 35.303 97.422-17.093 3 10.743"
}), React.createElement("path", {
  d: "M441 446.014c-181.022-12.28-508.68-62.63-371.14-165.785C207.4 177.074 387.832 229.061 398.7 149.92 413.319 43.49 97.422-8.906 3 18.93"
}), React.createElement("path", {
  d: "M441 454.201c-181.022-12.28-508.68-62.63-371.14-165.785C207.4 185.261 387.832 237.247 398.7 158.107 413.319 51.677 97.422-.719 3 27.117"
}), React.createElement("path", {
  d: "M441 459.659c-181.022-12.28-508.68-62.63-371.14-165.785C207.4 190.719 387.832 242.705 398.7 163.565 413.319 57.135 97.422 4.739 3 32.575"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "product-1_svg__filter0_f",
  x: 0.717,
  y: 0.357,
  width: 442.35,
  height: 462.3,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  result: "effect1_foregroundBlur"
})));

var SvgProduct1 = function SvgProduct1(props) {
  return React.createElement("svg", _extends({
    width: 444,
    height: 463,
    viewBox: "0 0 444 463",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,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";
export { SvgProduct1 as ReactComponent };